export const PFC_APPLICATION = '/pfc/application/'
export const PFC_APPLICATION_EDIT = `${PFC_APPLICATION}edit` as const
export const PFC_APPLICATION_RESET_PASSWORD = `${PFC_APPLICATION}reset_password` as const
export const PFC_APPLICATION_STATUS = `${PFC_APPLICATION}status/` as const
export const PFC_APPLICATION_UPDATE = `${PFC_APPLICATION}update` as const

export const PFC_APPLICATION_FORM = '/pfc/application_form/'
export const PFC_APPLICATION_FORM_ALL = `${PFC_APPLICATION_FORM}all` as const
export const PFC_APPLICATION_FORM_CURRENT = `${PFC_APPLICATION_FORM}current` as const
export const PFC_APPLICATION_FORM_FIELD_BATCH = `${PFC_APPLICATION_FORM}field/batch/` as const

export const PFC_PAYMENT = '/pfc/payment/'
export const PFC_PAYMENT_LIST = `${PFC_PAYMENT}` as const
export const PFC_PAYMENT_CREATE = `${PFC_PAYMENT}` as const
export const PFC_PAYMENT_ALL = `${PFC_PAYMENT}all` as const
export const PFC_PAYMENT_PRINCIPAL = `${PFC_PAYMENT}principal` as const
export const PFC_PAYMENT_CONFIRM = `${PFC_PAYMENT}confirm_payment/` as const
